<label class="section-label heading2">Summary - By Day Of Week</label>
<ng-container *ngIf="data$ | async as data; else empty">
  <ng-container *ngIf="totals$ | async as totals">
    <table mdbTable *ngIf="data.length != 0">
      <thead>
        <tr>
          <th class="table_heading1" [mdbTableSort]="data" sortBy="day">
            Day
          </th>
          <th
            class="table_heading1 no_mobile"
            [mdbTableSort]="data"
            sortBy="days"
          >
            # Days
          </th>
          <th class="table_heading1" [mdbTableSort]="data" sortBy="units">
            Units
          </th>
          <th
            class="table_heading1 no_mobile"
            [mdbTableSort]="data"
            sortBy="avgPrice"
          >
            Avg Price
          </th>
          <th
            class="table_heading1 no_mobile"
            [mdbTableSort]="data"
            sortBy="subtotal"
          >
            Sub Total
          </th>
          <th
            class="table_heading1 no_mobile"
            [mdbTableSort]="data"
            sortBy="serviceFees"
          >
            Service Fees
          </th>
          <th
            class="table_heading1 no_mobile"
            [mdbTableSort]="data"
            sortBy="tips"
          >
            Tips
          </th>
          <th
            class="table_heading1 no_mobile"
            [mdbTableSort]="data"
            sortBy="tipPercent"
          >
            Tip %
          </th>
          <th class="table_heading1" [mdbTableSort]="data" sortBy="total">
            Total
          </th>
          <th
            class="table_heading1 no_mobile"
            [mdbTableSort]="data"
            sortBy="redeemed"
          >
            # Redeemed
          </th>
          <th
            class="table_heading1"
            [mdbTableSort]="data"
            sortBy="redeemed_percentage"
          >
            Redeemed
          </th>
          <th
            class="table_heading1 no_mobile"
            [mdbTableSort]="data"
            sortBy="revenue_percentage"
          >
            % Revenue
          </th>
        </tr>
      </thead>
      <tbody class="body1">
        <tr class="hoverable" *ngFor="let element of data">
          <td>{{ map.get(element.key) }}</td>
          <td class="no_mobile">{{ element.days }}</td>
          <td>{{ element.units }}</td>
          <td class="no_mobile">{{ element.avgPrice | currency }}</td>
          <td class="no_mobile">{{ element.subtotal | currency }}</td>
          <td class="no_mobile">{{ element.fees | currency }}</td>
          <td class="no_mobile">{{ element.tips | currency }}</td>
          <td class="no_mobile">{{ element.tipPercent | percent }}</td>
          <td>{{ element.revenue | currency }}</td>
          <td class="no_mobile">{{ element.redeemedUnits }}</td>
          <td>{{ element.redeemedPercent | percent }}</td>
          <td class="no_mobile">
            {{ element.revenue / totals.revenue | percent }}
          </td>
        </tr>
      </tbody>
      <tfoot class="body1" *ngIf="data.length">
        <tr class="totals-row">
          <td class="left">TOTAL</td>
          <td class="no_mobile"></td>
          <td>{{ totals.units }}</td>
          <td class="no_mobile">{{ totals.avgPrice | currency }}</td>
          <td class="no_mobile">{{ totals.subtotal | currency }}</td>
          <td class="no_mobile">{{ totals.fees | currency }}</td>
          <td class="no_mobile">{{ totals.tips | currency }}</td>
          <td class="no_mobile">{{ totals.tipPercent | percent }}</td>
          <td>{{ totals.revenue | currency }}</td>
          <td class="no_mobile">{{ totals.redeemedUnits }}</td>
          <td class="right-mobile">{{ totals.redeemPercent | percent }}</td>
          <td class="right no_mobile">{{ 1 | percent }}</td>
        </tr>
      </tfoot>
    </table>
    <div class="caption" *ngIf="data.length != 0">
      *Date shown is based on event date, NOT purchase date
    </div>
  </ng-container>
  <div class="table-empty-state body1 " *ngIf="data.length == 0">
    No Orders Yet!
  </div>

  <ng-template *ngIf="data.length == 0">
    <div class="table-empty-state body1 ">
      No Orders Found!
    </div>
  </ng-template>
</ng-container>
<ng-template #empty>
  <div class="table-empty-state body1 "></div>
</ng-template>
